import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetLogsResponse = Paldock.LaravelConnectionCreator.Http.Responses.GetLogsResponse;
import GetScenarioResponse = App.Http.Responses.ConnectionCreatorNew.GetScenarioResponse;
import GetScenarioRunResponse = Paldock.LaravelConnectionCreator.Http.Responses.GetScenarioRunResponse;
import GetScenarioRunsResponse = Paldock.LaravelConnectionCreator.Http.Responses.GetScenarioRunsResponse;
import GetScenariosResponse = Paldock.LaravelConnectionCreator.Http.Responses.GetScenariosResponse;
import GraphScenarioResponse = Paldock.LaravelConnectionCreator.Http.Responses.GraphScenarioResponse;
import UpdateGraphScenario = Paldock.LaravelConnectionCreator.Http.Requests.UpdateGraphScenario;
import AppStoreScenarioRequest = App.Http.Requests.ConnectionCreatorNew.AppStoreScenarioRequest;
import GetApplicableScenariosRequest = App.Http.Requests.ConnectionCreatorNew.GetApplicableScenariosRequest;
import AppUpdateScenarioRequest = App.Http.Requests.ConnectionCreatorNew.AppUpdateScenarioRequest;
import GetLogsRequest = App.Http.Requests.ConnectionCreatorNew.GetLogsRequest;
import GetScenarioRequest = App.Http.Requests.ConnectionCreatorNew.GetScenarioRequest;
import GetScenarioRunRequest = App.Http.Requests.ConnectionCreatorNew.GetScenarioRunRequest;
import GetScenarioRunsRequest = App.Http.Requests.ConnectionCreatorNew.GetScenarioRunsRequest;
import GetScenariosRequest = App.Http.Requests.ConnectionCreatorNew.GetScenariosRequest;

export interface GetStepTypesResponse {
    types: string[];
}

class ConnectionCreatorApi extends TenantBaseApi {
    async getStepTypes(): Promise<GetStepTypesResponse> {
        return this.get<GetStepTypesResponse, never>("/connection-creator/step-types");
    }

    async getScenarios(request?: GetScenariosRequest): Promise<GetScenariosResponse> {
        return this.get<GetScenariosResponse, GetScenariosRequest>("/connection-creator/scenario", {
            params: request,
        });
    }

    async getApplicableScenarios(request: GetApplicableScenariosRequest): Promise<GetScenariosResponse> {
        return this.get<GetScenariosResponse, GetApplicableScenariosRequest>(
            "/connection-creator/scenario/applicable",
            {
                params: request,
            }
        );
    }

    async getScenario(scenarioId: string, request?: GetScenarioRequest): Promise<GetScenarioResponse> {
        return this.get<GetScenarioResponse, GetScenarioRequest>(`/connection-creator/scenario/${scenarioId}`, {
            params: request,
        });
    }

    async storeScenario(data: AppStoreScenarioRequest): Promise<GetScenarioResponse> {
        return this.post<GetScenarioResponse, AppStoreScenarioRequest>("/connection-creator/scenario", data);
    }

    async updateScenario(scenarioId: string, data: AppStoreScenarioRequest): Promise<GetScenarioResponse> {
        return this.put<GetScenarioResponse, AppStoreScenarioRequest>(
            `/connection-creator/scenario/${scenarioId}`,
            data
        );
    }

    async patchScenario(scenarioId: string, data: AppUpdateScenarioRequest): Promise<GetScenarioResponse> {
        return this.patch<GetScenarioResponse, AppUpdateScenarioRequest>(
            `/connection-creator/scenario/${scenarioId}`,
            data
        );
    }

    async destroyScenario(scenarioId: string): Promise<void> {
        return this.delete<void>(`/connection-creator/scenario/${scenarioId}`);
    }

    async getScenarioGraph(scenarioId: string): Promise<GraphScenarioResponse> {
        return this.get<GraphScenarioResponse, never>(`/connection-creator/scenario/${scenarioId}/graph`);
    }

    async updateScenarioGraph(scenarioId: string, data: UpdateGraphScenario): Promise<GraphScenarioResponse> {
        return this.patch<GraphScenarioResponse, UpdateGraphScenario>(
            `/connection-creator/scenario/${scenarioId}/graph`,
            data
        );
    }

    // Scenario Runs
    async getScenarioRuns(request?: GetScenarioRunsRequest): Promise<GetScenarioRunsResponse> {
        return this.get<GetScenarioRunsResponse, GetScenarioRunsRequest>("/connection-creator/scenario-runs", {
            params: request,
        });
    }

    async getScenarioRun(scenarioRunId: string, request?: GetScenarioRunRequest): Promise<GetScenarioRunResponse> {
        return this.get<GetScenarioRunResponse, GetScenarioRunRequest>(
            `/connection-creator/scenario-runs/${scenarioRunId}`,
            { params: request }
        );
    }

    // Logs
    async getLogs(request?: GetLogsRequest): Promise<GetLogsResponse> {
        return this.get<GetLogsResponse, GetLogsRequest>("/connection-creator/log", {
            params: request,
        });
    }
}

export const connectionCreatorApi = new ConnectionCreatorApi();
